import { useQuery } from '@tanstack/react-query';
import { getKanbanPagesAction } from '../actions/getKanbanPages.action';

export const useGetKanbanPages = () => {
  return useQuery({
    queryKey: ['kanban-pages'],
    queryFn: () => getKanbanPagesAction(),
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 10, // 10 minutes
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
};

